import styled from 'styled-components'
import { prop } from 'styled-tools'
import colorsOptions from '../../components/stories/fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../components/stories/fundamentals/text-styles/constants'

export const HelpItemWrapper = styled.a`
  background: ${prop('versionColor', colorsOptions.greys['grey-10'])};
  border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
  display: flex;
  position: relative;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;
  & > svg {
    flex: 0 0 auto;
  }
  width: 100%;
  border-radius: 8px 8px 0 0;
  &:hover {
    background: ${prop('versionColor', colorsOptions.docuToolsOrange['dt-10'])};
    & > svg {
      color: ${colorsOptions.docuToolsOrange['dt-10']};
    }
  }
  &:last-child {
    border-radius: 0 0 8px 8px;
  }
`

export const InsideListSearch = styled.li`
  z-index: 1001;
  color: ${colorsOptions.greys['grey-100']};
  padding: 0;
  float: left;
  list-style-type: none;
  div.searchBlock {
    display: block;
    float: none;
    position: absolute;
    top: 50px;
    right: 12px;
    background: ${colorsOptions.greys.white};
    z-index: 99999;
    padding: 0;
    margin: 0;
    width: 361px;
    box-shadow: 0 1px 5px 0 rgba(20, 26, 33, 0.2);

    &:after {
      position: absolute;
      left: 91.3%;
      top: -9px;
      width: 0;
      height: 0;
      content: '';
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid ${colorsOptions.greys.white};

      @media (min-width: 320px) and (max-width: 477px) {
        right: 1%;
      }
    }

    li {
      list-style-type: none;
      border-bottom: 1px solid ${colorsOptions.greys['grey-30']};
      cursor: default;
      &:last-child {
        border-bottom: none;
      }
    }
    @media (max-width: 477px) {
      width: 288px;
      right: 16px;
    }
  }
`

export const ItemIcon = styled.div`
  width: 36px;
  height: 36px;
  margin-right: 1rem;
  &:hover {
    svg {
      color: ${colorsOptions.docuToolsOrange['dt-10']};
    }
  }
`

export const ContentBlock = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  float: left;
  display: inline-block;
`
export const Title = styled.p`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
  color: ${colorsOptions.greys['grey-100']};
  word-wrap: break-word;
  & > span {
    color: ${prop('versionColor', colorsOptions.greys['grey-100'])};
  }
`

export const VersionTitle = styled.span`
  color: ${prop('versionColor', colorsOptions.greys['grey-100'])};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
`

export const SubTitle = styled.div`
  color: ${prop('versionColor', colorsOptions.greys['grey-100'])};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  &:hover {
    text-decoration: none;
  }
`
export const Anchor = styled.a`
  color: ${colorsOptions.secondaryColors.orange.strong};
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
`

export const RedInfo = styled.button`
  color: ${colorsOptions.secondaryColors.darkblue.strong};
  cursor: pointer;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
`
